export default __webpack_public_path__ + "static/media/Vadim.616829e0.jpg";